import React, { FC } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
} from "@mui/material";
import { File } from "../model/File";

interface FilePreviewDialogProps {
  file: File | null;
  onClose: () => void;
}

const FilePreviewDialog: FC<FilePreviewDialogProps> = ({ file, onClose }) => {
  return (
    <Dialog open={!!file} onClose={onClose}>
      <DialogTitle>Viewing File: {file?.name}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          File Type: {file?.type.toUpperCase()}
        </Typography>
        <Typography variant="body1">File Size: {file?.size}</Typography>
        <Typography variant="body1">Uploaded Date: {file?.date}</Typography>
        <Button onClick={onClose}>Close</Button>
      </DialogContent>
    </Dialog>
  );
};

export default FilePreviewDialog;
